import { useEffect, useState } from "react";
import { countdownTo } from "../lib/format";

export function CountdownTimer({ deadlineIso }: { deadlineIso: string }) {
  const [countdown, setCountdown] = useState(() => countdownTo(deadlineIso));

  useEffect(() => {
    const id = window.setInterval(() => setCountdown(countdownTo(deadlineIso)), 30_000);
    return () => window.clearInterval(id);
  }, [deadlineIso]);

  return (
    <span
      className={countdown.expired ? "badge badge--neutral" : "badge badge--warning"}
      role="timer"
    >
      {countdown.label}
    </span>
  );
}
